import { UPDATE_CAMPAIGN, UPDATE_CAMPAIGN_SUCCESS, UPDATE_CAMPAIGN_ERROR, UPDATE_CAMPAIGN_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateCampaign = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CAMPAIGN:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_CAMPAIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_CAMPAIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_CAMPAIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateCampaign;
